const pluralize = (number: number, singular: string, plural: string) =>
  `${number} ${number === 1 ? singular : plural}`;

export default pluralize;
